import { ResumeProfileModel } from 'generated-types/skills/resume_profile';
import { IconButton } from 'rsuite';
import PlusIcon from '@rsuite/icons/Plus';

const ProfileInfo = ({
    selectedResumeProfile,
    editAllowed,
    setEditMode,
}: {
    selectedResumeProfile: ResumeProfileModel | undefined;
    editAllowed: boolean;
    setEditMode: (value: boolean) => void;
}) => {
    return editAllowed && !selectedResumeProfile?.headline && !selectedResumeProfile?.about ? (
        <IconButton
            size="sm"
            icon={<PlusIcon />}
            appearance="primary"
            color="green"
            onClick={() => setEditMode(true)}
        >
            Add profile information
        </IconButton>
    ) : (
        <>
            <h4>{selectedResumeProfile?.headline}</h4>
            <p
                style={{
                    paddingTop: 10,
                    textAlign: 'justify',
                    whiteSpace: 'pre-wrap',
                }}
            >
                {selectedResumeProfile?.about}
            </p>
        </>
    );
};

export default ProfileInfo;
